import styled from 'styled-components/native';

import { DialogButton } from 'components/Button';

export default styled(DialogButton)`
  margin-top: ${({ primary }) => (primary ? 35 : 7)}px;
`;
